module.exports = __webpack_public_path__ + "static/media/Melissa1_preview.abaee7a2.jpg";